import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Tooltip from '@material-ui/core/Tooltip';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import { HiOutlineSearch, HiOutlineRefresh, HiOutlineAdjustments } from 'react-icons/hi';

const PageHeader = ({ title, breadcrumbs, actions, filters, onSearch, onClearSearch }) => {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [showFilters, setShowFilters] = useState(false);

    return (
        <div className="pp-page-header-wrap">
            <div className="page-header" style={{
                display: 'flex',
                alignItems: 'center',
                gap: isDesktop ? '12px' : '8px',
                flexWrap: 'nowrap',
            }}>
                <div style={{ marginRight: 'auto', minWidth: 0 }}>
                    {breadcrumbs && breadcrumbs.length > 0 && (
                        <Breadcrumbs aria-label="breadcrumb" className="pp-page-header-breadcrumbs">
                            {breadcrumbs.map((crumb, index) =>
                                crumb.onClick ? (
                                    <Link key={index} color="inherit" href="#" onClick={(e) => { e.preventDefault(); crumb.onClick(); }}>
                                        {crumb.label}
                                    </Link>
                                ) : (
                                    <Typography key={index} color="textPrimary">{crumb.label}</Typography>
                                )
                            )}
                        </Breadcrumbs>
                    )}
                    <Typography display="block" variant="h3" noWrap>
                        {title}
                    </Typography>
                </div>
                {isDesktop && filters}
                {isDesktop && (onSearch || onClearSearch) && (
                    <div className="flex-gap-6" style={{ flexShrink: 0 }}>
                        {onSearch && (
                            <Tooltip title="Search">
                                <IconButton size="small" onClick={onSearch} color="primary">
                                    <HiOutlineSearch size={20} />
                                </IconButton>
                            </Tooltip>
                        )}
                        {onClearSearch && (
                            <Tooltip title="Reset">
                                <IconButton size="small" onClick={onClearSearch}>
                                    <HiOutlineRefresh size={20} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                )}
                {!isDesktop && filters && (
                    <IconButton size="small" onClick={() => setShowFilters(!showFilters)} color={showFilters ? 'primary' : 'default'}>
                        <HiOutlineAdjustments size={20} />
                    </IconButton>
                )}
                {actions && actions.length > 0 && (
                    <div className="flex-gap-6" style={{ flexShrink: 0 }}>
                        {actions.map((action, index) =>
                            isDesktop ? (
                                <Button
                                    key={index}
                                    variant={action.variant || 'contained'}
                                    color={action.color || 'primary'}
                                    onClick={action.onClick}
                                    href={action.href}
                                    download={action.download}
                                    disabled={action.disabled}
                                    endIcon={action.icon}
                                    size="small"
                                >
                                    {action.label}
                                </Button>
                            ) : (
                                <Tooltip key={index} title={action.label}>
                                    <span>
                                        <IconButton
                                            size="small"
                                            onClick={action.onClick}
                                            href={action.href}
                                            download={action.download}
                                            disabled={action.disabled}
                                            color={action.color || 'primary'}
                                            className={(action.variant || 'contained') === 'contained'
                                                ? `pp-icon-btn-contained-${action.color || 'primary'}`
                                                : undefined}
                                        >
                                            {action.icon}
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            )
                        )}
                    </div>
                )}
            </div>
            {!isDesktop && showFilters && filters && (
                <div className="table-filter-container">
                    {filters}
                    {(onSearch || onClearSearch) && (
                        <div className="flex-gap-6">
                            {onSearch && (
                                <Tooltip title="Search">
                                    <IconButton size="small" onClick={onSearch} color="primary">
                                        <HiOutlineSearch size={20} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {onClearSearch && (
                                <Tooltip title="Reset">
                                    <IconButton size="small" onClick={onClearSearch}>
                                        <HiOutlineRefresh size={20} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
